var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": "",
      "id": "callComplete"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "fixed-header",
    attrs: {
      "offset-sm1": "",
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "green",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'activeCall'
        });
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.completeCall')) + "\n        ")]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("apps")])], 1), _c('v-list', [_vm.callDetail.status != 'Available' && _vm.callDetail.status != 'Accepted' ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'media',
        params: {
          id: _vm.callDetail.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.media')))])], 1) : _vm._e(), _vm.callDetail.status != 'Available' && _vm.callDetail.status != 'Accepted' ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'scans',
        params: {
          id: _vm.callDetail.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.scans')))])], 1) : _vm._e(), _vm.callDetail.status != 'Available' ? _c('v-list-tile', {
    on: {
      "click": function click($event) {
        _vm.dialogReset = true;
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.resetCall')))])], 1) : _vm._e()], 1)], 1)], 1)], 1), !_vm.isTravelingHomeAtStore ? _c('v-flex', {
    attrs: {
      "offset-sm1": "",
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "mb-3": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    class: !_vm.callDetail.visit_status ? 'red--text text--darken-2' : ''
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.visitStatus')) + " :\n              "), _vm.callDetail.visit_status ? _c('h2', [_vm._v("\n                " + _vm._s(_vm.callDetail.visit_status) + "\n              ")]) : _c('h2', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.required')))])])]), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_vm.isReady ? _c('v-btn', {
    attrs: {
      "color": !_vm.callDetail.visit_status ? 'red darken-2' : '',
      "dark": "",
      "fab": "",
      "id": "visitStatusButton"
    },
    nativeOn: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e()], 1)], 1), _c('v-divider')], 1), _c('v-flex', {
    attrs: {
      "mt-3": "",
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "mb-3": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    class: !_vm.callDetail.travel_started_at ? 'red--text' : ''
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.travelStartTime')) + ":")]), _c('h2', [_c('datetime', {
    ref: "travelStartDatetimePicker",
    attrs: {
      "max-datetime": _vm.now(),
      "format": "dd/LL/yyyy HH:mm",
      "placeholder": "Select date",
      "type": "datetime"
    },
    model: {
      value: _vm.travelStartDatetime,
      callback: function callback($$v) {
        _vm.travelStartDatetime = $$v;
      },
      expression: "travelStartDatetime"
    }
  })], 1)]), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_vm.isReady ? _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openPicker('travelStartDatetimePicker');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("access_time")])], 1) : _vm._e()], 1)], 1), _c('v-divider')], 1), _c('v-flex', {
    attrs: {
      "mt-3": "",
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "mb-3": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    class: !_vm.callDetail.arrived_at ? 'red--text' : ''
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.onSiteTime')) + ":")]), _c('h2', [_c('datetime', {
    ref: "onSiteDatetimePicker",
    attrs: {
      "min-datetime": _vm.minOnSiteDatetime,
      "max-datetime": _vm.maxOnSiteDatetime,
      "format": "dd/LL/yyyy HH:mm",
      "placeholder": "Select date",
      "type": "datetime"
    },
    model: {
      value: _vm.onSiteDatetime,
      callback: function callback($$v) {
        _vm.onSiteDatetime = $$v;
      },
      expression: "onSiteDatetime"
    }
  })], 1)]), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_vm.isReady ? _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openPicker('onSiteDatetimePicker');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("access_time")])], 1) : _vm._e()], 1)], 1), _c('v-divider')], 1), _c('v-flex', {
    attrs: {
      "mt-3": "",
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "mb-3": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    class: !_vm.offSiteDatetime ? 'red--text' : ''
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.offSiteTime')) + ":")]), _c('h2', [_c('datetime', {
    ref: "offSiteDatetimePicker",
    attrs: {
      "min-datetime": _vm.minOffSiteDatetime,
      "max-datetime": _vm.maxOffSiteDatetime,
      "format": "dd/LL/yyyy HH:mm",
      "placeholder": "Select date",
      "type": "datetime"
    },
    model: {
      value: _vm.offSiteDatetime,
      callback: function callback($$v) {
        _vm.offSiteDatetime = $$v;
      },
      expression: "offSiteDatetime"
    }
  })], 1)]), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_vm.isReady ? _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openPicker('offSiteDatetimePicker');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("access_time")])], 1) : _vm._e()], 1)], 1), _c('v-divider')], 1), _c('v-form', [_c('v-flex', {
    attrs: {
      "mt-3": "",
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-textarea', {
    ref: "workCarriedout",
    attrs: {
      "error": !this.workDescriptionValue ? true : false,
      "label": _vm.$vuetify.t('$vuetify.calls.workCarriedOut'),
      "rules": [_vm.rules.required],
      "value": _vm.callDetail.work_description,
      "id": "workCarriedOut",
      "outline": ""
    },
    nativeOn: {
      "keyup": function keyup($event) {
        return _vm.changeWorkCarriedOut(_vm.workDescriptionValue);
      }
    },
    model: {
      value: _vm.workDescriptionValue,
      callback: function callback($$v) {
        _vm.workDescriptionValue = $$v;
      },
      expression: "workDescriptionValue"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error": !this.clientNameValue ? true : false,
      "label": _vm.$vuetify.t('$vuetify.calls.clientName'),
      "rules": [_vm.rules.required],
      "value": _vm.callDetail.accepted_by_name,
      "id": "clientName",
      "outline": ""
    },
    on: {
      "input": function input(value) {
        _vm.changeClientName(value);
      }
    },
    nativeOn: {
      "keyup": function keyup($event) {
        return _vm.changeClientName(_vm.clientNameValue);
      }
    },
    model: {
      value: _vm.clientNameValue,
      callback: function callback($$v) {
        _vm.clientNameValue = $$v;
      },
      expression: "clientNameValue"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error": !_vm.clientPositionValue ? true : false,
      "label": _vm.$vuetify.t('$vuetify.calls.clientPosition'),
      "rules": [_vm.rules.required],
      "value": _vm.callDetail.accepted_by_position,
      "id": "clientPosition",
      "outline": ""
    },
    on: {
      "input": function input(value) {
        _vm.changeClientPosition(value);
      }
    },
    model: {
      value: _vm.clientPositionValue,
      callback: function callback($$v) {
        _vm.clientPositionValue = $$v;
      },
      expression: "clientPositionValue"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Client Satisfaction, how did we do?")]), _c('div', {
    staticClass: "text-xs-center sentiment"
  }, [_c('v-icon', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "6rem"
    },
    attrs: {
      "color": "green",
      "x-large": "",
      "value": "Good"
    },
    on: {
      "click": function click($event) {
        return _vm.setSentiment('Good');
      }
    }
  }, [_vm._v("\n              sentiment_satisfied\n            ")]), _c('v-icon', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "6rem"
    },
    attrs: {
      "color": "orange",
      "x-large": "",
      "value": "Satisfactory"
    },
    on: {
      "click": function click($event) {
        return _vm.setSentiment('Satisfactory');
      }
    }
  }, [_vm._v("\n              sentiment_neutral\n            ")]), _c('v-icon', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "6rem"
    },
    attrs: {
      "color": "red",
      "x-large": "",
      "value": "Below Average"
    },
    on: {
      "click": function click($event) {
        return _vm.setSentiment('Below Average');
      }
    }
  }, [_vm._v("\n              sentiment_dissatisfied\n            ")]), _c('h3', [_vm._v(_vm._s(_vm.callDetail.sentiment))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.sentiment,
      expression: "sentiment"
    }],
    ref: "text",
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.sentiment
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.sentiment = $event.target.value;
      }
    }
  })], 1), _vm.callDetail.sentiment == 'Below Average' ? _c('v-textarea', {
    attrs: {
      "solo": "",
      "value": _vm.callDetail.why_sentiment,
      "label": "Please enter a reason why..."
    },
    nativeOn: {
      "keyup": function keyup($event) {
        return _vm.setWhySentiment(_vm.why_sentiment);
      }
    },
    model: {
      value: _vm.why_sentiment,
      callback: function callback($$v) {
        _vm.why_sentiment = $$v;
      },
      expression: "why_sentiment"
    }
  }) : _vm._e()], 1), _c('v-flex', {
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_vm.currentSignature ? _c('div', [_vm._v("\n            Current signature\n            "), _c('v-img', {
    staticClass: "white lighten-2 media",
    attrs: {
      "src": _vm.currentSignature.url ? _vm.currentSignature.url : _vm.currentSignature.src
    }
  }, [_c('v-layout', {
    attrs: {
      "slot": "placeholder",
      "align-center": "",
      "fill-height": "",
      "justify-center": "",
      "ma-0": ""
    },
    slot: "placeholder"
  }, [_c('v-progress-linear', {
    attrs: {
      "color": "grey lighten-5",
      "indeterminate": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _c('signature-pad', {
    attrs: {
      "callId": _vm.callId,
      "onlyEvent": true,
      "buttonText": "Client Signature",
      "signatureType": "accepted_by_signature",
      "title": "Sign the Document"
    },
    on: {
      "signature-updated": _vm.signatureUpdated
    }
  }), _c('v-divider')], 1)], 1), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_vm.endPhoto && _vm.endPhoto.type == 'image' && _vm.endPhotoLoading == false ? _c('v-img', {
    staticClass: "grey lighten-2 media mb-3",
    attrs: {
      "src": _vm.endPhoto.url ? _vm.endPhoto.url : _vm.endPhoto.base64,
      "aspect-ratio": "1"
    }
  }) : _vm._e(), _vm.endPhotoLoading == true ? _c('v-layout', {
    attrs: {
      "slot": "placeholder",
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    },
    slot: "placeholder"
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "grey"
    }
  })], 1) : _vm._e()], 1), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs6": "",
      "mb-2": ""
    }
  }, [_c('camera-dialog', {
    attrs: {
      "stage": "complete"
    },
    on: {
      "photo-taken": _vm.photoTaken
    }
  })], 1), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs6": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "uploadButton btn-file",
    attrs: {
      "color": "blue darken-2 mb-3"
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("attach_file")]), _c('div', {
    staticClass: "title text-xs-center"
  }, [_vm._v("Upload Photo")]), _c('input', {
    ref: "photoFiles",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFiles
    }
  })], 1)], 1)], 1)], 1)], 1), _vm.callDetail.worksheet_required == true && !_vm.hasWorksheet ? _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n          Worksheet Required\n        ")]), _c('v-card', {
    class: _vm.callDetail.status === 'Arrival Completed' ? 'completePanel' : '',
    attrs: {
      "to": {
        path: '/form/engineer-worksheet'
      },
      "color": "cyan darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("book")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.worksheet')) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": "/forms",
      "color": "orange darken-1",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("dvr")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n              Other Forms\n            ")])], 1)], 1)], 1), _vm.getCompletedCallForms.length > 0 ? _c('v-flex', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', [_vm._v("Completed Forms")]), _vm._l(_vm.getCompletedCallForms, function (item) {
    return _c('v-list-tile', {
      key: item.slug
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check")])], 1)], 1);
  })], 2)], 1) : _vm._e(), _vm.attachedDocuments == false ? _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "px-3": "",
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.noDocumentsAttached')) + "\n        ")])], 1) : _vm._e()], 1) : _vm._e(), _vm.displayFooter && !_vm.isTravelingHomeAtStore ? _c('v-flex', {
    staticClass: "footer",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "color": "red",
      "dark": "",
      "id": "completeCallButton",
      "large": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.timeValidation();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.sendToOffice')) + "\n      ")])], 1) : _vm._e(), _vm.isTravelingHomeAtStore ? _c('v-flex', {
    attrs: {
      "mx-3": "",
      "offset-sm1": "",
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "mb-3": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    class: !_vm.travelEndDatetime ? 'red--text' : ''
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.travelEndTime')) + ":")]), _c('h2', [_c('datetime', {
    ref: "travelEndDatetimePicker",
    attrs: {
      "max-datetime": _vm.now(),
      "format": "dd/LL/yyyy HH:mm",
      "placeholder": "Select date",
      "type": "datetime"
    },
    model: {
      value: _vm.travelEndDatetime,
      callback: function callback($$v) {
        _vm.travelEndDatetime = $$v;
      },
      expression: "travelEndDatetime"
    }
  })], 1)]), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_vm.isReady ? _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openPicker('travelEndDatetimePicker');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("access_time")])], 1) : _vm._e()], 1)], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-4 mb-3",
    attrs: {
      "block": "",
      "color": "red",
      "id": "travelEndButton",
      "large": ""
    },
    on: {
      "click": function click($event) {
        return _vm.travelEnd();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.travelEnd')) + "\n        ")]), _c('v-layout', {
    staticClass: "caption",
    attrs: {
      "row": "",
      "justify-center": "",
      "mt-3": ""
    }
  }, [_vm._v("\n          or  \n          "), _c('a', {
    on: {
      "click": function click($event) {
        _vm.endtraveldialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.cancelTravelHome')))])])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "423"
    },
    model: {
      value: _vm.endtraveldialog,
      callback: function callback($$v) {
        _vm.endtraveldialog = $$v;
      },
      expression: "endtraveldialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.cancelTravelHomeConfirmation')))]), _c('v-card-text', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.cancelTravelHomeConfirmationText')))]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.endtraveldialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        return _vm.cancelTravelHome();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.yesCancelTravelHome')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "id": "visitStatusDialog",
      "width": "600"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$vuetify.t('$vuetify.calls.pickPhrase'))
    }
  }), _c('v-carousel', {
    staticClass: "carousel elevation-0",
    attrs: {
      "cycle": false,
      "hide-delimiters": "",
      "light": ""
    },
    model: {
      value: _vm.statusOptionId,
      callback: function callback($$v) {
        _vm.statusOptionId = $$v;
      },
      expression: "statusOptionId"
    }
  }, _vm._l(_vm.options, function (option, id) {
    return _c('v-carousel-item', {
      key: id,
      staticClass: "text-xs-center px-5"
    }, [_c('h3', [_vm._v(_vm._s(option.message))])]);
  }), 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "id": "confirmStatusButton"
    },
    on: {
      "click": function click($event) {
        return _vm.changeVisitStatus(_vm.statusOptionId);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.select')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "id": "completeDialog",
      "width": "500"
    },
    model: {
      value: _vm.completeDialog,
      callback: function callback($$v) {
        _vm.completeDialog = $$v;
      },
      expression: "completeDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.completeCallHeader')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.completeCallBody')) + "\n        "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    model: {
      value: _vm.isTravelingHome,
      callback: function callback($$v) {
        _vm.isTravelingHome = $$v;
      },
      expression: "isTravelingHome"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.travelingHome')) + "\n            ")])])], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.completeDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "id": "completeVisitButton"
    },
    on: {
      "~click": function click($event) {
        return _vm.completeCall.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.completeCallConfirm')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "id": "timeErrorsDialog",
      "width": "500"
    },
    model: {
      value: _vm.timeErrorsDialog,
      callback: function callback($$v) {
        _vm.timeErrorsDialog = $$v;
      },
      expression: "timeErrorsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.checkRequiredFields')) + "\n      ")]), _c('v-list', [[_vm._l(_vm.timeErrors, function (error) {
    return _c('v-list-tile', {
      key: error,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("warning")])], 1), _c('v-list-tile-content', [_vm._v("\n              " + _vm._s(error) + "\n            ")])], 1);
  }), _c('v-divider')]], 2), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        ;
        _vm.timeErrorsDialog = false, _vm.timeErrors = [];
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.ok')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.dialogReset,
      callback: function callback($$v) {
        _vm.dialogReset = $$v;
      },
      expression: "dialogReset"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallHeader')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallBody')) + "\n      ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialogReset = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.confirmReset
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallConfirm')) + "\n        ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.errorDialog,
      callback: function callback($$v) {
        _vm.errorDialog = $$v;
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.checkRequiredFields')) + "\n      ")]), _c('v-card-text', [_c('v-container', {
    attrs: {
      "pa-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red",
      "x-large": ""
    }
  }, [_vm._v("warning")])], 1), _c('v-flex', {
    attrs: {
      "pl-3": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.someOfTheRequiredFieldsAreEmpty')) + "\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.errorDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.ok')) + "\n        ")])], 1)], 1)], 1), _c('proximity-dialog', {
    ref: "proximityDialog",
    attrs: {
      "distance-to-site": this.distanceToSite
    },
    on: {
      "accept-proximity-warning": _vm.confirmProximity
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }